// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { ShopByCategoryModel } from "@werner/App/Services/ShopByCategoryService";
import { Draft } from "immer";

export interface ShopByCategoryState {
    data: { [key: string]: { isLoading: boolean; data?: ShopByCategoryModel; failedMessage?: string } };
}

const initialState: ShopByCategoryState = {
    data: {},
};

const reducer = {
    "xShopByCategory/BeginLoadShopbyCategories": (draft: Draft<ShopByCategoryState>, action: { key: string }) => {
        draft.data[action.key] = {
            isLoading: true,
            failedMessage: "",
        };
    },
    "xShopByCategory/FailedToLoadShopbyCategories": (
        draft: Draft<ShopByCategoryState>,
        action: { failedMessage: string; key: string },
    ) => {
        draft.data[action.key] = {
            isLoading: false,
            failedMessage: action.failedMessage,
        };
    },
    "xShopByCategory/CompleteLoadShopbyCategories": (
        draft: Draft<ShopByCategoryState>,
        action: { data: ShopByCategoryModel; key: string },
    ) => {
        if (action.key) {
            draft.data[action.key] = {
                isLoading: false,
                data: action.data,
                failedMessage: "",
            };
        }
    },
};

const xShopByCategory = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xShopByCategory = xShopByCategory;

export type xShopByCategoryState = {
    xShopByCategory: ShopByCategoryState;
} & ApplicationState;

type xShopByCategoryReducers = {
    [key: string]: typeof xShopByCategory;
};

export type xShopByCategoryActions = Parameters<xShopByCategoryReducers[keyof xShopByCategoryReducers]>[1];
